var app = angular.module("leonardo");

var TemplatesExportDialog = function($scope, AccountUserService, AuthDataService) {

  $scope.filters = $scope.ngDialogData.filters;

  $scope.emails = 1;

  $scope.emails_send = [];
  if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.user) {
    $scope.emails_send.push(AccountUserService.currentAccountUser.user.email);
  }
  else {
    $scope.emails_send.push(AuthDataService.authData.user.email);
  }

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.emailsError = function() {
    if (!$scope.Form.$submitted) {
      return false;
    }
    else if ($scope.emails_send.length === 0) {
      return true;
    }
    else {
      var error = true;
      angular.forEach($scope.emails_send, function(value){
        if (value) {
          error = false;
        }
      });
      return error;
    }
  };

  $scope.submit = function() {
    if ($scope.emailsError()) return;
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) return;
    var account = $scope.filters.account || $scope.account;
    $scope.confirm({
      account: account || null,
      filename: $scope.report_title ? $scope.filename : null,
      report_title: $scope.report_title ? $scope.report_title : null,
      response_email_recipients: $scope.emails_send
    });
  };

};

app.controller('TemplatesExportDialog', ['$scope', 'AccountUserService', 'AuthDataService', TemplatesExportDialog]);
